module.exports = __webpack_public_path__ + "static/media/Transaction-risk-engine Alert Page.14531a19.png";